import { captureServiceException } from '@client/monolith/core/plugins/sentry/helper';
import { OrderPay } from '@ankorstore/api-internal/OrderPay';
import {
  FETCH_ORDERPAY_ACCOUNT_INFO,
  CANCEL_ORDERPAY_ACCOUNT,
} from '@client/monolith/legacy/store/account/orderpay/action-types';
import { SET_ORDERPAY_ACCOUNT_INFO } from '@client/monolith/legacy/store/account/orderpay/mutations-types';
import { PatchOrderPayAccountStatusEnum2 } from '@client/api-internal/data-contracts';

const orderPayService = new OrderPay();

export const actions = {
  [FETCH_ORDERPAY_ACCOUNT_INFO]: async ({ commit }, { userUuid }: { userUuid: string }) => {
    try {
      const orderpay = await orderPayService.getOrderPayAccount(userUuid);
      commit(SET_ORDERPAY_ACCOUNT_INFO, orderpay);
    } catch (e) {
      if (e.status === 404) {
        // No orderpay account
        return;
      }
      captureServiceException(e);
    }
  },
  [CANCEL_ORDERPAY_ACCOUNT]: async ({ commit }, { brandUuid }: { brandUuid: string }) => {
    try {
      const orderpay = await orderPayService.patchOrderPayAccount(
        brandUuid,
        {
          data: {
            type: 'order-pay-account',
            id: brandUuid,
            attributes: {
              subscription: { status: PatchOrderPayAccountStatusEnum2.Cancelled },
            },
          },
        },
        {
          type: 'application/vnd.api+json',
        }
      );
      commit(SET_ORDERPAY_ACCOUNT_INFO, orderpay);
    } catch (e) {
      captureServiceException(e);
    }
  },
};
